<template>
  <v-dialog
    v-model="show"
    max-width="640"
    @click:outside="close"
    data-test-id="walletReservationDetailDialog"
  >
    <v-card>
      <v-card-title class="d-flex align-center">
        <v-icon left>mdi-bookmark-outline</v-icon>
        Reservation Detail
        <v-spacer />
        <v-btn icon @click="close" data-test-id="walletReservationDetailCloseBtn">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider />

      <v-card-text class="pt-4">
        <div v-if="loading" class="d-flex justify-center align-center py-8">
          <v-progress-circular indeterminate color="primary" />
        </div>

        <v-simple-table v-else-if="reservation" dense>
          <tbody>
            <tr v-for="(value, key) in reservation" :key="key">
              <td class="font-weight-bold" style="width: 40%">{{ key }}</td>
              <td style="word-break: break-all">{{ value }}</td>
            </tr>
          </tbody>
        </v-simple-table>

        <div v-else class="grey--text text-center py-4">
          No reservation data found.
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text @click="close" data-test-id="walletReservationDetailDoneBtn">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "WalletReservationDetail",

  props: {
    reservationId: {
      type: String,
      required: true,
    },
    domain: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      show: true,
      reservation: null,
      loading: false,
    };
  },

  async created() {
    await this.loadReservation();
  },

  methods: {
    async loadReservation() {
      this.loading = true;
      try {
        const data = await this.$store.$coreApi.coreWalletApi.getReservation(
          this.domain,
          this.reservationId
        );
        if (!data) return;
        this.reservation = data;
      } finally {
        this.loading = false;
      }
    },

    close() {
      this.show = false;
      this.$emit("close");
    },
  },
};
</script>
